import { useState, useEffect } from 'react'
import { config } from '@grupoboticario/flora'

const mobileBp = parseFloat(config.media.mobile?.replace(/\D/g, ''))

const getInitialValue = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth <= mobileBp
  }

  return false
}

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(getInitialValue())
  const [observer, setObserver] = useState<ResizeObserver>()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setObserver(
        () =>
          new window.ResizeObserver(([entry]) => setIsMobile(entry.contentRect.width <= mobileBp)),
      )
    }
  }, [])

  useEffect(() => {
    if (observer) {
      observer.observe(document.body)
      return () => observer.disconnect()
    }
  }, [observer])

  return isMobile
}
